import { connectSocket } from "../socket";

export function createVoiceCallSignaling(localUser, remoteUser) {

  const socket = connectSocket();

  let onOffer, onAnswer, onICE, onEnd;

  // 🔥 HANDLERS (named functions)
  const handleOffer = ({ from, offer }) => {
    if (from === remoteUser && onOffer) onOffer(offer);
  };

  const handleAnswer = ({ from, answer }) => {
    if (from === remoteUser && onAnswer) onAnswer(answer);
  };

  const handleICE = ({ from, candidate }) => {
    if (from === remoteUser && onICE) onICE(candidate);
  };

  const handleEnd = ({ from }) => {
    if (from === remoteUser && onEnd) onEnd();
  };

  // ✅ ATTACH LISTENERS
  socket.on("call_offer", handleOffer);
  socket.on("call_answer", handleAnswer);
  socket.on("call_ice", handleICE);
  socket.on("call_end", handleEnd);

  function sendOffer(offer) {
    socket.emit("call_offer", {
      to: remoteUser,
      offer,
      type: "voice"
    });
  }

  function sendAnswer(answer) {
    socket.emit("call_answer", {
      to: remoteUser,
      answer
    });
  }

  function sendICE(candidate) {
    socket.emit("call_ice", {
      to: remoteUser,
      candidate
    });
  }

  function endCall() {
    socket.emit("call_end", { to: remoteUser });
    if (onEnd) onEnd();
  }

  // 🔥 CLEANUP (MOST IMPORTANT)
  function cleanup() {
    socket.off("call_offer", handleOffer);
    socket.off("call_answer", handleAnswer);
    socket.off("call_ice", handleICE);
    socket.off("call_end", handleEnd);
  }

  return {

    sendOffer,
    sendAnswer,
    sendICE,
    endCall,
    cleanup, // ✅ expose cleanup

    set onOffer(fn) { onOffer = fn; },
    set onAnswer(fn) { onAnswer = fn; },
    set onICE(fn) { onICE = fn; },
    set onEnd(fn) { onEnd = fn; }

  };

}